/***************************************************************
5/25/2017
Alexander Self
utils.js: Utility functions
- Misc. utility functions for use throughout the application
***************************************************************/
import moment from 'moment';
import React from 'react';
import randomColor from 'random-color';
const Materialize = window.Materialize;
const $ = window.$;

export function mapField(h) {
 return h.field;
}

export function groupBy(arr, fn) {
  arr.map(typeof fn === 'function' ? fn : val => val[fn]).reduce((acc, val, i) => {
    acc[val] = (acc[val] || []).concat(arr[i]);
    return acc;
  }, {});
}

/**
* getSelectedValue(): Extracts the selected value from a drop down select field
* @param {String} id, id of form input
* @returns {String} form value selected
* @called-in: ['/components/timesheets/create/timesheet_form.js']
**/
export function getSelectedValue(id) {
  let selectedVal = '';
  [].forEach.call(document.querySelectorAll(`#${id} :checked`), (elm) => {
    selectedVal = elm.value;
  });
  return selectedVal;
}
/**
* setPaycodeInWorkPerformed(): Extracts the selected value from a drop down select field and sets to workperformed
* @param {String} inputId, id of text input
* @returns {String} selectId, id of select input
* @called-in: ['/components/timesheets/create/timesheet_form.js','/components/timesheets/edit/timesheet_edit_form.js']
**/
export function setPaycodeInWorkPerformed(inputId, selectId) {
  let workPerformed = document.getElementById(inputId);

  [].forEach.call(document.querySelectorAll(`#${selectId} :checked`), (elm) => {
    workPerformed.value = elm.id;
  });
  return workPerformed;
}

export function setPaycodeInWorkPerformed2(inputId, selectId) {
  let workPerformed = document.getElementById(inputId);

  return workPerformed;
}

/**
* setCCSubInWorkPerformed(): Extracts the selected value from a drop down select field and sets to workPerformed
* @param {String} inputId, id of text input
* @returns {String} selectId, id of select input
* @called-in: ['/components/timesheets/create/timesheet_form.js']
**/
export function setCCSubInWorkPerformed(inputId, ccId, subId) {
  let workPerformed = document.getElementById(inputId);
  let cc, sub;
  [].forEach.call(document.querySelectorAll(`#${ccId} :checked`), (elm) => {
    cc = elm.value;
  });
  [].forEach.call(document.querySelectorAll(`#${subId} :checked`), (elm) => {
    sub = elm.id;
  });
  let costCenter = cc.split('-')[1];
  let work = `${costCenter}, ${sub}`;
  workPerformed.value = work;
  return workPerformed;
}

/**
* getSelectedValues(): Extracts the selected values from a multi-select drop down
* @param {String} id, id of form input
* @returns {String} form values selected
* @called-in:
**/
export function getSelectedValues(id) {
  let selectedVals = [];
  [].forEach.call(document.querySelectorAll(`#${id} :checked`), (elm) => {
    if (elm.value !== '') selectedVals.push(elm.value);
  });
  return selectedVals;
}

/**
* handleWorkPerformed(): Handles Work Performed form checks
* @returns {Object} hours, trainer values, True or False
* @called-in:
**/
export function handleWorkPerformed() {
  let hours, trainer;
  let paycode = getSelectedValue('paycode');
  let workPerformed = document.getElementById('workPerformed').value;
  workPerformed = $.trim(workPerformed);
  // Handle secondaryHours
  if (document.getElementById('hours').value === '') hours = 0.00;
  else hours = document.getElementById('hours').value;
  if (document.getElementById('trainer').checked) trainer = 1;
  else trainer = 0;

  // Handle Work Performed
  if (workPerformed === '') {
    Materialize.toast('Please input Work Performed', 3000, 'red rounded');
    return { hours, trainer, check: false };
  }
  // handle paycodes
  if ((parseInt(paycode, 10) > 13 && parseInt(paycode, 10) < 44) && hours > 0.00) {
    Materialize.toast('Only add hours for paycodes 1-13, 45, 50-65', 3000, 'red rounded');
    return { hours, trainer, check: false };
  } /*if (((parseInt(paycode, 10) >= 1 && parseInt(paycode, 10) <= 13) || (parseInt(paycode, 10) >= 43 && parseInt(paycode, 10) <= 44)) && hours <= 1.00) {
    Materialize.toast('Add hours greater than 1 for paycodes 1-13, 42-44', 3000, 'red rounded');
    return { hours, trainer, check: false };
  }*/
  // Handle costCenter & subAccount
  if (getSelectedValue('subAccount') === '' && getSelectedValue('costCenterCode') !== '') {
    Materialize.toast('Select a Sub-account with a Cost Center', 3000, 'red rounded');
    return { hours, trainer, check: false };
  }
  // handle costCenter, subAccount, workPerformed & hours
  if (getSelectedValue('subAccount') !== '' && getSelectedValue('costCenterCode') !== '' && document.getElementById('workPerformed').value !== '' && hours < 0.1) {
    Materialize.toast('Enter hours for work with Cost Center and Sub-account', 3000, 'red rounded');
    return { hours, trainer, check: false };
  }

  /* Special Cases: Added 6/18/2018 on Finance department request
     Cost centers within 12-32 need a field
     If completing garage work; require an equipment number
  */
  if (isInRange(Number(getSelectedValue('costCenterCode').split('-')[0])) && getSelectedValue('field') === '') {
    Materialize.toast('Please select a field for cost centers 12 - 32', 3000, 'red rounded');
    return { hours, trainer, check: false };
  }
  // Added 6.20.24
  // Values for equipment and trailer; should only be one equipment number due to mechanical work
  if (getSelectedValue('costCenterCode').split('-')[0] === '62' && (document.getElementById('equipmentNo').value !== '' && getSelectedValue('equipmentTrailerNo') !== '')) {
    Materialize.toast('Please add only one equipment number with cost center 62', 3000, 'red rounded');
    return { hours, trainer, check: false };
  }

  if (getSelectedValue('costCenterCode').split('-')[0] === '62' && (document.getElementById('equipmentNo').value === '' && getSelectedValue('equipmentTrailerNo') === '') ) {
    Materialize.toast('Please add an equipment number with cost center 62', 3000, 'red rounded');
    return { hours, trainer, check: false };
  }

  /* Special case for bug: Added 4/6/20 on Finance department request
     Supervisors have discovered a way to submit subaccounts not contained in a cost center
     i.e. Submitting 31-Hand Harvest-71 and 71-18-131
  */
  let _sub = getSelectedValue('subAccount').split('-')[1];
  let _cc = getSelectedValue('costCenterCode').split('-')[0];
  if ((getSelectedValue('subAccount') !== '' && getSelectedValue('costCenterCode') !== '') && (_sub !== _cc)) {
    Materialize.toast('Please select a subaccount belonging to the correct cost center', 3000, 'red rounded');
    return { hours, trainer, check: false };
  }

  /* Special case for bug: Added 9.1.21 Users figured out how to add a subaccount without a cost center
     and the work performed = undefined, {subaccount}
     ex: subaccount: 72-32-130, workperformed: undefined, Time Travel Operator, costCenter: ''
  */
  if ((getSelectedValue('subAccount') !== '' && getSelectedValue('costCenterCode') === '') && (workPerformed.match(/undefined/))) {
    Materialize.toast('Please select a cost center and subaccount', 3000, 'red rounded');
    return { hours, trainer, check: false };
  }


  return { hours, trainer, check: true };
}

function isInRange(number)
{
  return number >= 12 && number <= 32;
}

/* Handles workPerformed form checks */
export function handleWorkPerformedEdit() {
  let hours, trainer;
  let paycode = getSelectedValue('edit-ts-paycode');

  // Handle secondaryHours
  if (document.getElementById('edit-ts-hours').value === '') hours = 0.00;
  else hours = document.getElementById('edit-ts-hours').value;
  if (document.getElementById('edit-ts-trainer').checked) trainer = 1;
  else trainer = 0;

  // Handle Work Performed
  if (document.getElementById('edit-ts-workPerformed').value === '') {
    Materialize.toast('Please input Work Performed', 3000, 'red rounded');
    return { hours, trainer, check: false };
  }
  // Handle paycodes
  if ((parseInt(paycode, 10) > 13 && parseInt(paycode, 10) < 42) && hours > 0.00) {
    Materialize.toast('Only add hours for paycodes 1-13, 45, 50-65', 3000, 'red rounded');
    return { hours, trainer, check: false };
  } /*if (((parseInt(paycode, 10) >= 1 && parseInt(paycode, 10) <= 13) || (parseInt(paycode, 10) >= 43 && parseInt(paycode, 10) <= 44)) && hours <= 0.00) {
    Materialize.toast('Add hours greater than 1 for paycodes 1-13, 42-44', 3000, 'red rounded');
    return { hours, trainer, check: false };
  }*/

  // Handle costCenter & subAccount
  if (getSelectedValue('edit-ts-subAccount') === '' && getSelectedValue('edit-ts-costCenterCode') !== '') {
    Materialize.toast('Select a Sub-account with a Cost Center', 3000, 'red rounded');
    return { hours, trainer, check: false };
  }
  // handle costCenter, subAccount, workPerformed & hours
  if (getSelectedValue('edit-ts-subAccount') !== '' && getSelectedValue('edit-ts-costCenterCode') !== '' && document.getElementById('edit-ts-workPerformed').value !== '' && hours < 0.1) {
    Materialize.toast('Enter hours for work with Cost Center and Sub-account', 3000, 'red rounded');
    return { hours, trainer, check: false };
  }

  /* Special Cases: Added 6/18/2018 on Finance department request
     Cost centers within 12-32 need a field
     If completing garage work; require an equipment number
     */
  if (isInRange(Number(getSelectedValue('edit-ts-costCenterCode').split('-')[0])) && getSelectedValue('edit-tsworkPerformed-field') === '') {
    Materialize.toast('Please select a field for cost centers 12 - 32', 3000, 'red rounded');
    return { hours, trainer, check: false };
  }
  // Added 6.20.24
  // Values for equipment and trailer; should only be one equipment number due to mechanical work
  if (getSelectedValue('edit-ts-costCenterCode').split('-')[0] === '62' && (document.getElementById('edit-ts-equipmentNo').value !== '' && getSelectedValue('edit-ts-equipmentTrailerNo') !== '')) {
    Materialize.toast('Please add only one equipment number with cost center 62', 3000, 'red rounded');
    return { hours, trainer, check: false };
  }
  // No value at all for equipment or trailer
  if (getSelectedValue('edit-ts-costCenterCode').split('-')[0] === '62' && (document.getElementById('edit-ts-equipmentNo').value === '' && getSelectedValue('edit-ts-equipmentTrailerNo') === '')) {
    Materialize.toast('Please add an equipment number with cost center 62', 3000, 'red rounded');
    return { hours, trainer, check: false };
  }

 

  /*if ((getSelectedValue('edit-ts-costCenterCode').split('-')[0] === '62' && document.getElementById('edit-ts-equipmentNo').value === '') && getSelectedValue('equipmentTrailerNo') !== '') {
    Materialize.toast('Please add an equipment number with cost center 62', 3000, 'red rounded');
    return { hours, trainer, check: false };
  }*/

  /* Special case for bug: Added 4/6/20 on Finance department request
     Supervisors have discovered a way to submit subaccounts not contained in a cost center
     i.e. Submitting 31-Hand Harvest-71 and 71-18-131
  */
  let _sub = getSelectedValue('edit-ts-subAccount').split('-')[1];
  let _cc = getSelectedValue('edit-ts-costCenterCode').split('-')[0];
  if ((getSelectedValue('edit-ts-subAccount') !== '' && getSelectedValue('edit-ts-costCenterCode') !== '') && (_sub !== _cc)) {
    Materialize.toast('Please select a subaccount belonging to the correct cost center', 3000, 'red rounded');
    return { hours, trainer, check: false };
  }

  /* Special case for bug: Added 9.1.21 Users figured out how to add a subaccount without a cost center
     and the work performed = undefined, {subaccount}
     ex: subaccount: 72-32-130, workperformed: undefined, Time Travel Operator, costCenter: ''
  */
  if ((getSelectedValue('edit-ts-subAccount') !== '' && getSelectedValue('edit-ts-costCenterCode') === '')
      && (document.getElementById('edit-ts-workPerformed').value.match(/undefined/))) {
      Materialize.toast('Please select a cost center and subaccount', 3000, 'red rounded');
      return { hours, trainer, check: false };
  }

  return { hours, trainer, check: true };
}

/**
* handleEquipmentNo(): Ensures users select the full equipment no and desc from autocomplete
* @param {String} id, id of form input
* @returns error if no equipmentNo is properly selected
* @called-in:
**/
export function handleEquipmentNo(id, equipmentNo) {
  if (document.getElementById(id).value !== '') {
    let equip = equipmentNo.find((e) => `${e.equipmentNo} - ${e.description}` === document.getElementById(id).value);
    if (!equip) {
      Materialize.toast('Please select the equipment from the autocomplete list', 4000, 'rounded red');
      return false;
    }
  }
  return true;
}

/**
* validateEquipmentSelected(): Ensures users select the full equipment no and desc from autocomplete
* @param {String} id, id of form input
* @returns {Boolean} true or false depending on if the equipment exists
* @called-in: [actions/harvest_actions.js]
**/
export function validateEquipmentSelected({
  equipment,
  equipmentList
}) {
  if (equipment === '') {
    Materialize.toast('Please select the equipment from the autocomplete list', 4000, 'rounded red');
    return false;
  }
  let equip = equipmentList.find((e) => `${e.equipmentNo} - ${e.description}` === equipment)
  if (!equip) {
    Materialize.toast('Please select the equipment from the autocomplete list', 4000, 'rounded red');
    return false;
  }
  return true;
}

/* Computes the total hours worked */
export function totalHours(work) {
  if (work.length === 0) return 0;
  else if (work.length === 1) {
    return work[0].hours;
  }

  let sum = 0;
  for (let i = 0; i < work.length; i++) {
    sum += parseFloat(work[i].hours);
  }

  return sum.toFixed(2);
}

export function totalCount(arr, type) {
  if (arr.length === 0) return 0;
  switch (type) {
    case "hours":
      if (arr.length === 1) {
        return arr[0].hours;
      }
      let hours = arr.reduce((prev, cur) => { return prev + parseFloat(cur.hours) }, 0);
      if (hours === "") hours = 0.00;
      return hours.toPrecision(3);
    case "trees":
      if (arr.length === 1) {
        return arr[0].trees;
      }
      let trees = arr.reduce((prev, cur) => { return prev + parseFloat(cur.trees) }, 0);
      if (trees === "") trees = 0.00;
      return trees.toPrecision(3);
    case "bags":
      if (arr.length === 1) {
        return arr[0].bags;
      }
      let bags = arr.reduce((prev, cur) => { return prev + parseFloat(cur.bags) }, 0);
      if (bags === "") bags = 0.00;
      return bags.toPrecision(3);
    case "incentive":
      if (arr.length === 1) {
        return arr[0].incentive;
      }
      let incentive = arr.reduce((prev, cur) => { return prev + parseFloat(cur.incentive) }, 0);
      if (incentive === "") incentive = 0.00;
      return incentive.toPrecision(4);
    case "pIndex":
      if (arr.length === 1) {
        return arr[0].pIndex;
      }
      let pIndex = arr.reduce((prev, cur) => { return prev + parseFloat(cur.pIndex) }, 0);
      let avgIndex = (pIndex / arr.length);

      return avgIndex.toPrecision(4);
    default:
      return 0;
  }

}

/* Generates a unique general purpose ID */
export const generateGUID = () => {
  var d = new Date().getTime();
  if(window.performance && typeof window.performance.now === "function"){
      d += performance.now(); //use high-precision timer if available
  }
  var uuid = 'xxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (d + Math.random()*16)%16 | 0;
      d = Math.floor(d/16);
      // eslint-disable-next-line
      return (c=='x' ? r : (r&0x3|0x8)).toString(16);
  });
  return uuid;
};

/* Generates a unique Timesheet ID */
export const generateTSID = () => {
  var d = new Date().getTime();
  if(window.performance && typeof window.performance.now === "function"){
      d += performance.now(); //use high-precision timer if available
  }
  var uuid = 'xxxxxxxx-xxxxxxxx-xxxxxxxx-xxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (d + Math.random()*16)%16 | 0;
      d = Math.floor(d/16);
      // eslint-disable-next-line
      return (c=='x' ? r : (r&0x3|0x8)).toString(16);
  });
  return uuid;
};

/* Creates an obj containing all form elements */
export function packageForm(id) {
  let elements = document.getElementById(`${id}`).elements;
  let formObj = {};
  // eslint-disable-next-line
  for (let i = 0, element; element = elements[i++];) {
    if (element.id === "") continue;
    formObj[element.id] = element.value;
    if (element.checked === true) formObj[element.id] = 1
  }
  return formObj;
}
/**
* packageDashForm(): Packages form element values with dashes in ids
* @param {String} id, id of form
* @returns {Object} formObj, key value form object
* @called-in: ['/components/timesheets/create/gang_autofill_form.js]
**/
/* The absurdity: for form ids using a dash */
export function packageDashForm(id) {
  let elements = document.getElementById(`${id}`).elements;
  let formObj = {};
  // eslint-disable-next-line
  for (let i = 0, element; element = elements[i++];) {
    if (element.id === "") continue;
    if (element.id.split('-').length === 2) formObj[element.id.split('-')[1]] = element.value;
    if (element.id.split('-').length === 3) formObj[element.id.split('-')[2]] = element.value;
    if (element.checked === true && element.id.split('-').length === 2) {
      formObj[element.id.split('-')[1]] = 1;
    }
  }

  return formObj;
}

/* For Gang Timesheets
  Parses form array of dynamically added form elements (users + bags, trees)
  and splits unique ids and groups them according to their ids
  array starts as [312x-trees: '', 312x-bags: '', eid: '' ]
  after: [{ eid: 312x, trees: '', bags: '' }] array of objs
*/
// Work Performed is for employee meetings, travel, ot ,etc
export function extractUsersFromForm(formObj, workPerformed) {
  let empArr = [];
  let empObj = {};
  let newFormObj = {};
  let tempKey;
  let subTimesheet = {};
  let subTimesheets = [];
  /* First filter to extract form elements into formatted objects */
  for (let key in formObj) {
    if (tempKey !== key && key.split('-')[1] === 'eid') {
      empObj.eid = formObj[key];
    } else if (tempKey !== key && key.split('-')[1] === 'positionType') {
      empObj.positionType = formObj[key];
    } else if (tempKey !== key && key.split('-')[1] === 'subgrade') {
      empObj.subgrade = formObj[key];
    } else if (tempKey !== key && key.split('-')[1] === 'trees') {
      empObj.trees = formObj[key];
    } else if (tempKey !== key && key.split('-')[1] === 'bags') {
      empObj.bags = formObj[key];
    } else if (tempKey !== key && key.split('-')[1] === 'field') {
      empObj.field = formObj[key];
    } else if (tempKey !== key && key.split('-')[1] === 'hours') {
      empObj.hours = formObj[key];
    } else if (tempKey !== key && key.split('-')[1] === 'block') {
      empObj.block = formObj[key];
      empObj.id = generateGUID();
      tempKey = key;
      empArr.push(empObj);
      empObj = {};
    } else if (tempKey !== key && key.split('-').length === 3) {
      continue;
    } else {
      newFormObj[key] = formObj[key];
    }
  }
  /* Second filter to extract form elements into formatted objects */
  for (let key in formObj) {
    if (tempKey !== key && key.split('-')[2] === 'eid') {
      empObj.eid = formObj[key];
    } else if (tempKey !== key && key.split('-')[2] === 'trees') {
      empObj.trees = formObj[key];
    } else if (tempKey !== key && key.split('-')[2] === 'bags') {
      empObj.bags = formObj[key];
    } else if (tempKey !== key && key.split('-')[2] === 'field') {
      empObj.field = formObj[key];
    } else if (tempKey !== key && key.split('-')[2] === 'hours') {
      empObj.hours = formObj[key];
    } else if (tempKey !== key && key.split('-')[2] === 'block') {
      empObj.block = formObj[key];
      empObj.id = generateGUID();
      tempKey = key;
      empArr.push(empObj);
      empObj = {};
    }
  }

  for (let key in formObj) {
    if (tempKey !== key && key.split('-')[1] === 'eid') {
      subTimesheet.eid = formObj[key];
    } else if (tempKey !== key && key.split('-')[1] === 'paycode') {
      subTimesheet.paycode = formObj[key];
    } else if (tempKey !== key && key.split('-')[1] === 'paycodeDescription') {
      subTimesheet.workPerformed = formObj[key];
    } else if (tempKey !== key && key.split('-')[1] === 'paycodeHours') {
      subTimesheet.hours = formObj[key];
      if (subTimesheet.hours === '') subTimesheet.hours = 0.00;
      tempKey = key;
      subTimesheet = {
        ...subTimesheet,
        tempGrade: '',
        costCenterCode: '',
        subAccount: '',
        field: '',
        block: '',
        equipmentNo: '',
        equipmentTrailerNo: '',
        differential: ''
      };
      subTimesheets.push(subTimesheet);
      subTimesheet = {};
    }
  }

  newFormObj.employees = empArr;
  newFormObj.emps = [];
  var summaryOfHours, harvest, temp, subTS, work;
  let eObj = {};
  // Create employee timesheet object: contains all form info per employee
  for (let e of newFormObj.employees) {
    if (e.eid !== temp) {
      work = workPerformed.reduce((previous, current) => { return previous + parseFloat(current.hours, 10) }, 0);
      summaryOfHours = newFormObj.employees.filter((item) => item.eid === e.eid).reduce((previous, current) => { return previous + parseFloat(current.hours,10) }, 0);
      harvest = newFormObj.employees.filter((item) => item.eid === e.eid);
      subTS = subTimesheets.filter((item) => item.eid === e.eid);
      temp = e.eid;
      summaryOfHours += work;
      if (subTS.length > 0) {
        if (subTS[0].paycode === '') {
          eObj.subTimesheet = [];
        } else eObj.subTimesheet = subTS;
      }
      if (harvest.length > 0) { /* Case: Employee is sick, excused, vacation ,etc */
        if (harvest[0].hours === '') {
          harvest = [];
        }
      }
      eObj.startTime = newFormObj.gangStartTime;
      eObj.endTime = newFormObj.gangEndTime;
      eObj.gang = newFormObj.gangNo;
      eObj.shift = newFormObj.gangShift;
      eObj.location = newFormObj.gangLocation;
      eObj.date = newFormObj.gangWorkDate;
      eObj.eid = e.eid;
      eObj.positionType = e.positionType;
      eObj.subgrade = e.subgrade || '';
      eObj.harvest = harvest.map((h) => {
        return { ...h,
          round: Number(formObj.round)
        }
      });
      eObj.summaryOfHours = summaryOfHours.toFixed(2);
      if (summaryOfHours > 8) {
        eObj.regHours = 8;
        eObj.otHours = (summaryOfHours - 8).toFixed(2);
      } else {
        eObj.otHours = 0;
        eObj.regHours = summaryOfHours.toFixed(2);
      }
      if (Object.keys(eObj).length > 0) {
        newFormObj.emps = newFormObj.emps.concat(eObj);
      }
      if (isNaN(eObj.regHours)) {
        eObj.regHours = 0.00;
        eObj.otHours = 0.00;
        eObj.summaryOfHours = 0.00;
      }/* Case: Employee is getting paid and need to account for hours */
      if (subTS.length > 0) {
        if (parseFloat(subTS[0].hours) > 0) {
          eObj.regHours = parseFloat(eObj.regHours);
          eObj.summaryOfHours = parseFloat(eObj.summaryOfHours);
          eObj.regHours += parseFloat(subTS[0].hours);
          eObj.otHours = 0.00;
          eObj.summaryOfHours += parseFloat(subTS[0].hours);
        }
      }
      // eslint-disable-next-line
      workPerformed.map((w) => eObj.subTimesheet.push(w));
      eObj = {};
    }
  }

  newFormObj.emps = uniq(newFormObj.emps);
  delete newFormObj.employees;
  delete newFormObj.gangStartTime;
  delete newFormObj.gangEndTime;
  delete newFormObj.gangNo;
  delete newFormObj.gangShift;
  delete newFormObj.gangLocation;
  delete newFormObj.gangWorkDate;
  for (let key in newFormObj) {
    if (key !== ('emps' || 'gangTravel' || 'gangMeeting')) delete newFormObj[key];
  }

  return newFormObj;
}

function uniq(a) {
  var seen = {};
  return a.filter(function(item) {
      return seen.hasOwnProperty(item.eid) ? false : (seen[item.eid] = true);
  });
}
/* Clears any form based on id */
export function clearForm(formID) {
  return document.getElementById(`${formID}`).reset();
}

/* Alerts user about required fields */
export function handleFormChecking(form, cb) {
  switch (true) {
    case (form.date === ''):
      cb('Please enter a date before submitting');
      return 1;
    /*case (form.location === ''):
      cb('Please select a location before submitting');
      return 1;
    case (form.shift === ''):
      cb('Please select a shift before submitting');
      return 1;
    case (form.regHours === 0):
      cb('Please enter regular hours before submitting');
      return 1;
    case (form.startTime === ''):
      cb('Please enter a start time before submitting');
      return 1;
    case (form.endTime === ''):
      cb('Please enter a end time before submitting');
      return 1;*/
    default:
      return 0;
  }
}
/*
  Returns current date
*/
export function getCurrentDate() {
  let today = moment();
  return today.format('YYYY-MM-DD');
}

/*
  Prefills timesheet edit forms when user pulls information
  Edit form have unique ids that match the database column names
*/
export function fillEditForm(ts) {
  let editForm = document.getElementById("edit-ts-form").elements;
  let timesheet = ts.timesheet;
  timesheet.round = ts.round;
  // eslint-disable-next-line
  for (let i = 0, element; element = editForm[i++];) {
    if (element.id === "") continue;
    let id = element.id.split('-')[2];
    for (let key in timesheet) {
      if (key === id) {
        if (key === 'date') {
          element.value = timesheet[key].split('T')[0];
        } else {
          element.value = timesheet[key];
        }
        if (key === 'dustPay' && timesheet[key] === 1) {
          element.checked = true;
        } else continue;
      }
    }
  }
}
/*
  Prefills timesheet individual forms when user needs to edit before submitting
*/
export function fillIndividualWorkForm(work, id) {
  // eslint-disable-next-line
  switch (id) {
    case 'second-ts-form':
      let form = document.getElementById(id).elements;
      // eslint-disable-next-line
      for (let i = 0, element; element = form[i++];) {
        let id = element.id;
        for (let key in work) {
          if (key === id) element.value = work[key];
          if (key === 'trainer' && work[key] === 1) element.checked = true;
        }
      }
      return;
    case 'edit-second-ts-form':
      let _form = document.getElementById(id).elements;
      // eslint-disable-next-line
      for (let i = 0, element; element = _form[i++];) {
        let id = element.id.split('-')[2];
        for (let key in work) {
          if (key === id) element.value = work[key];
          if (key === 'trainer' && work[key] === 1) element.checked = true;
        }
      }
      return;
    case 'gang-work-form':
      document.getElementById('gangCostCenterCode').value = work.costCenterCode;
      document.getElementById('gangSubAccount').value = work.subAccount;
      document.getElementById('gangWorkPerformed').value = work.workPerformed;
      document.getElementById('gangField').value = work.field;
      document.getElementById('gangHours').value = work.hours;
      return;
    default:
      return;
  }
}
/* Takes an array of data and maps to an object
  where the keys are the values;
  Built for materializecss autocomplete
 */
export function mapEmployeeForAutoComplete(data) {
  var dataObj = {};
  for (let i = 0; i < data.length; i++) {
    dataObj[`${data[i].firstName} ${data[i].lastName}`] = null;
  }
  return dataObj;
}

export function mapEquipmentForAutoComplete(data) {
  var dataObj = {};
  for (let i = 0; i < data.length; i++) {
    dataObj[`${data[i].equipmentNo} - ${data[i].description}`] = null;
  }
  return dataObj;
}

/* Display an error as a toast */
export function errorToast(msg) {
  Materialize.toast(msg, 4000, 'red rounded');
  return;
}

/*
  Find a particular employee by first and last name
  returning only the find function will return duplicates every time.
  @called-in: ['/actions/harvest_actions.js','irrigation/irrigation_actions.js',
  'irrigation/components/irrigation_display.js']
*/
export function findEmployeeByName(name, employees) {
  let emp;
  emp = employees.find((e) => `${e.firstName} ${e.lastName}` === name);
  if (emp === undefined || emp === null || emp === '') return {} 
  return emp;
}

/*
  Combines the basic weekly schedule with any daily schedule additions.
  If there are no daily schedule additions, iterate through dates and create
  daily schedule array from basic weekly schedule form
*/
export function combineSchedules(main, daily) {
  let fullSchedule = {
    schedule: {}, // scheduleID, totalExpectedHours, startDate, endDate
    dailySchedule: [] // Individual work day objs
  };
  let schedule = [], totalExpectedHours = 0;
  // For daily schedule replace
  if (daily.length > 0) { // Add one extra day because loop exits the day prior to endDate
    for (let m = moment(main.startDate); m.isBefore(moment(main.endDate).add(1,'days')); m.add(1, 'days')) {
      // Keep track of which days have been individually assigned so there is no redundancy in scheduling
      var day;
      // Daily Schedule array
      for (let i = 0; i < daily.length; i++) {
        //if there is a date that matches, create the individual schdule
        if (daily[i].workdate === m.format('YYYY-MM-DD')) {
          day = daily[i].workdate;
          totalExpectedHours += parseInt(daily[i].hours, 10);
          // Check for days off
          if (daily[i].dayOff === 'on') {
            schedule.push({
              workdate: daily[i].workdate,
              startTime: "",
              endTime: "",
              typeOfWork: daily[i].typeOfWork,
              hours: parseInt(daily[i].hours, 10),
              location: "",
              field: "",
              description: daily[i].description
            });
          } else {
            schedule.push({
              workdate: daily[i].workdate,
              startTime: daily[i].startTime,
              endTime: daily[i].endTime,
              typeOfWork: daily[i].typeOfWork,
              hours: parseInt(daily[i].hours, 10),
              location: daily[i].location,
              field: daily[i].field,
              description: daily[i].description
            });
          }
        }
      }
      if (day === m.format('YYYY-MM-DD')) continue;
      else {
        totalExpectedHours += parseInt(main.hours, 10);
        schedule.push({
          workdate: m.format('YYYY-MM-DD'),
          startTime: main.startTime,
          endTime: main.endTime,
          typeOfWork: main.typeOfWork,
          hours: parseInt(main.hours, 10),
          location: main.location,
          field: main.field,
          description: main.description
        });
      }
    }
  } else { // There are no custom days
    for (let m = moment(main.startDate); m.isBefore(moment(main.endDate).add(1,'days')); m.add(1, 'days')) {
      totalExpectedHours += parseInt(main.hours, 10);
      schedule.push({
        workdate: m.format('YYYY-MM-DD'),
        startTime: main.startTime,
        endTime: main.endTime,
        typeOfWork: main.typeOfWork,
        hours: parseInt(main.hours, 10),
        location: main.location,
        field: main.field,
        description: main.description
      });
    }
  }
  fullSchedule.dailySchedule = schedule;
  fullSchedule.schedule = {
    scheduleID: generateTSID(),
    totalExpectedHours,
    startDate: main.startDate,
    endDate: main.endDate
  };

  return fullSchedule;
}

/*
  If the day off checkbox is selected, disable all fields except work date
  For schedules
*/
export function disableDailyScheduleForm() {
  let dayOff = document.getElementById('schedule-dayOff');
  let dailyForm = document.getElementById('daily-schedule-form').elements;
  if (dayOff.checked === true) {
    // eslint-disable-next-line
    for (let i = 0, element; element = dailyForm[i++];) {
      if (element.id === 'schedule-dayOff') continue;
      if (element.id === 'schedule-daily-workdate') continue;
      if (element.id === 'schedule-add-day') continue;
      element.disabled = true;
    }
  }
  else {
    // eslint-disable-next-line
    for (let i = 0, element; element = dailyForm[i++];) {
      if (element.id === 'schedule-dayOff') continue;
      if (element.id === 'schedule-daily-workdate') continue;
      if (element.id === 'schedule-add-day') continue;
      element.disabled = false;
    }
  }
}

export function disableDailyEditScheduleForm() {
  let dayOff = document.getElementById('edit-schedule-dayOff');
  let dailyForm = document.getElementById('daily-edit-schedule-form').elements;
  if (dayOff.checked === true) {
    // eslint-disable-next-line
    for (let i = 0, element; element = dailyForm[i++];) {
      if (element.id === 'edit-schedule-dayOff') continue;
      if (element.id === 'edit-schedule-workdate') continue;
      if (element.id === 'edit-schedule-add-day') continue;
      element.disabled = true;
    }
  }
  else {
    // eslint-disable-next-line
    for (let i = 0, element; element = dailyForm[i++];) {
      if (element.id === 'edit-schedule-dayOff') continue;
      if (element.id === 'edit-schedule-workdate') continue;
      if (element.id === 'edit-schedule-add-day') continue;
      element.disabled = false;
    }
  }
}

export function onDummyComplete() {
  return;
}
/* Fills in an edit form */
export function fillEdit(formId, form) {
  let editForm = document.getElementById(formId).elements;

  // eslint-disable-next-line
  for (let i = 0, element; element = editForm[i++];) {
    if (element.id === "") continue;
    let id = element.id.split('-')[2];
    for (let key in form) {
      if (key === id) {
        if (key === 'date') {
          element.value = form[key].split('T')[0];
        } else {
          element.value = form[key];
        }
        if (key === 'partTime' && form[key] === 1) {
          element.checked = true;
        } else element.checked = false;
      }
    }
  }
}

/* Fills in an edit form */
export function fillEdit2({ formId, form }) {
  let editForm = document.getElementById(formId).elements;

  // eslint-disable-next-line
  for (let i = 0, element; element = editForm[i++];) {
    if (element.id === "") continue;
    let id = element.id.split('-')[1];
    for (let key in form) {
      if (key === id) {
        element.value = form[key];
      }
    }
  }
}

export function getManagerName(eid, employees) {
  let manager = employees.filter((e) => e.eid === eid);
  console.log(manager);
}

/*
  Maps fields in summaries; account for multiple entries or a single one
  Called in: components/timesheets/view/timesheet_view_individual_summary, timesheet_view_summary
*/
export function mapFields(fields) {
  try {
    let _fields = JSON.parse(fields);
    if (_fields.length === 0) return (<span><b>None</b></span>);
    if (_fields.length === 1) return (<span>{_fields[0]}</span>);
    if (_fields.length > 1) {
      return _fields.map((f) => (
        <span key={f}>{f} </span>
      ));
    }
    return fields;
  } catch (e) {
    /* Catches a failed parse attempt;  */
    // Multiple values
    try {
      let _fields = JSON.parse(fields);
      if (_fields.length > 1) {
        return _fields.map((f) => (
          <span key={f}>{f} </span>
        ));
      }
      // just return single field
    } catch (e) {
      return (<span>{fields} </span>);
    }

  }
}

/* Prefills a multi select dropdown
   Called in:
*/
export function fillMultiSelect(vals, id='') {
  let multi = document.getElementById(id);
  let options = [];
  try {
    let _vals = JSON.parse(vals);

    for (let i = 0; i < multi.length; i++) {
      for (let j = 0; j < _vals.length; j++) {
        if (multi[i].value === _vals[j]) {
          multi[i].selected = 'selected';
          options.push(multi[i].value);
        }
      }
    }
    $('input.select-dropdown').val(options);
  } catch (e) { // Single value
    for (let i = 0; i < multi.length; i++) {
      if (multi[i].value === vals) {
        multi[i].selected = 'selected';
        $('input.select-dropdown').val(multi[i].value);
        break;
      }
    }
  }
}

export function getDateString(date) {
  return JSON.stringify(date).replace(/["]+/g, '').split('T')[0];
}

/**
* disableEnableForm(): Disables and enables a form
* @param {String} id, id of form input
* @returns
* @called-in: ['/components/finance/finance_payrates.js']
**/
export function disableEnableForm(id, disable) {
  if (disable) {
    let form = document.getElementById(id).elements;

    // eslint-disable-next-line
    for (let i = 0, element; element = form[i++];) {
      element.readOnly = true;
      element.disabled = true;
    }
    return;
  }
  let form = document.getElementById(id).elements;

  // eslint-disable-next-line
  for (let i = 0, element; element = form[i++];) {
    element.readOnly = false;
    element.disabled = false;
  }
  return;
}


/**
* determineReportOpts(): Returns a object of form options a user specified
* @param {Object} opts: Report form options
* @returns {Object} formOptions: user selected form options
* @called-in: ['/actions/harvest_actions.js']
**/
export function determineReportOpts(opts) {
  let obj = {};
  for (let key in opts) {
    if (opts[key] === 'on' || key === 'dateFrom' ||
      key === 'dateTo' || key === 'employee') continue;
    else obj[key] = opts[key];
  }

  return obj;
}

/**
* dynamicSort(): Returns a sorted array by dynamic prop asc
* @param {String} property: Property to sort by
* @returns {Array} sorted array
* @called-in: [''/components/harvest/view/harvest_view.js'']
**/
export function dynamicSort(property) {
    if (property === 'date') {
      let sortOrder = 1;
      if(property[0] === "-") {
          sortOrder = -1;
          property = property.substr(1);
      }
      return function (a,b) {
        var result = (new Date(a[property]) < new Date(b[property])) ? 1 : (new Date(a[property]) > new Date(b[property])) ? -1 : 0;
        return result * sortOrder;
      }
    }
    let sortOrder = 1;
    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a,b) {
      var result = (a[property] < b[property]) ? 1 : (a[property] > b[property]) ? -1 : 0;
      return result * sortOrder;
    }
}
/**
* dynamicReverseSort(): Returns a sorted array by dynamic prop desc
* @param {String} property: Property to sort by
* @returns {Array} sorted array
* @called-in: ['/components/harvest/view/harvest_view.js']
**/
export function dynamicReverseSort(property) {
    if (property === 'date') {
      let sortOrder = 1;
      if(property[0] === "-") {
          sortOrder = -1;
          property = property.substr(1);
      }
      return function (a,b) {
        var result = (new Date(a[property]) < new Date(b[property])) ? -1 : (new Date(a[property]) > new Date(b[property])) ? 1 : 0;
        return result * sortOrder;
      }
    }
    let sortOrder = 1;
    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a,b) {
      var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      return result * sortOrder;
    }
}

/**
* generateGraphLabelsAndData(): Accepts an array of data and returns a set of labels and selected datapoints
* @param {String} dataProp: Property to extract from array
* @param {String} labelProp: Label to map to data prop
* @param {Array} arr: the entire data array
* @returns {Array} data: the array which will be mapped to a single property
* @called-in: ['/components/harvest/view/harvest_report_view.js']
**/
export function generateGraphDataAndLabels(dataProp, labelProp, arr) {
  if (!(dataProp && labelProp && arr)) return { data: [], labels: [] };

  let data = arr.map((a) => a[dataProp]);
  let labels = arr.map((a) => a[labelProp]);

  return { data, labels };
}


/**
* generateRandomColors(): Returns an array of hex colors; used for graph colors on unknown array sizes
* @param {Array} arr: the entire data array
* @returns {Array} colors: an array of hex colors
* @called-in: ['/components/harvest/view/harvest_report_view.js']
**/
export function generateRandomColors(arr) {
  if (!(arr)) return [];

  let colors = arr.map((d) => {
    let color = randomColor();
    let r = color.hexString();
    return r;
  });

  return colors;
}


/* END */



// WEBPACK FOOTER //
// ./src/utils.js